<template>
	<div style="height: 750px; overflow:scroll;">

		<el-row style="margin-top: 10%; padding: 0 5%;">
			<el-input placeholder="搜索" prefix-icon="el-icon-search" v-model="filterText" size="mini">
			</el-input>
		</el-row>

		<el-row style="margin-top: 5%;">
			<el-tree class="filter-tree" :props="defaultProps" lazy :load="loadNode" :filter-node-method="filterNode"
				ref="tree" :highlight-current="true" @node-click="parentFind">
				<div slot-scope="{data}">
					<div style="display: inline-block;">
						<span>{{data.organize_name}}({{data.organize_number}}人)</span>
					</div>
				</div>
			</el-tree>
		</el-row>

	</div>
</template>

<script>
	export default {
		props: ["condition", "form"],
		data() {
			return {

				//搜索
				filterText: "",

				//数据展示字段
				defaultProps: {
					label: "organize_name",
					children: "organizeList",
				},

				node_had: {},
				resolve_had: {},

			};
		},
		watch: {
			filterText(val) {
				this.$refs["tree"].filter(val);
			}
		},
		methods: {
			//懒加载
			async loadNode(node, resolve) {
				if (node.level === 0) {
					// this.node_had = node; //这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
					// this.resolve_had = resolve; //同上，把node.level == 0的resolve也存起来
					return resolve(await this.GroupFind());
				} else if (node.level === 1) {
					return resolve(await this.Find('', 'group'));
				} else {
					resolve(await this.Find(node.data.id, ''));
				}
			},
			//查询组织架构
			async Find(e, spare8) {
				var url = "organize/findHierarchy";
				var record = {
					organize_id: e == undefined ? '' : e,
					spare8: spare8 == undefined ? '' : spare8
				};
				var result = [];
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						result = data;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}
				return result;
			},
			//获取集团信息
			async GroupFind() {
				var result = [];
				var group = await this.$globals.AxiosPost("dictionaries/groupFind", {});
				result = [{
					organize_name: group.data.group_company,
					id: group.data.id,
					organize_number: group.data.headcount,
					group_director_id: group.data.group_director_id,
					group_director_name: group.data.group_director_name
				}]

				if (this.$props["condition"] != undefined && this.$props["condition"] != null) {
					this.$props["condition"].project_id = '';
					this.$props["condition"].project_name = group.data.group_company;
					this.$props["condition"].flag = 'group';
				}

				if (this.$props["form"] != undefined && this.$props["form"] != null) {
					this.$props["form"].id = group.data.id;
					this.$props["form"].staff_ids = group.data.group_director_id != '' && group.data
						.group_director_id != null ? group.data.group_director_id.split(',') : '';
					this.$props["form"].staff_name = group.data.group_director_name;
					this.$props["form"].organize_name = group.data.group_company;
				}

				return result;
			},
			//刷新父页面
			parentFind(data, node) {

				this.curNode = node;

				if (this.$props["condition"] != undefined && this.$props["condition"] != null) {
					this.$props["condition"].project_id = data.id;
					this.$props["condition"].project_name = data.organize_name;
				}

				if (this.$props["form"] != undefined && this.$props["form"] != null) {
					this.$props["form"].id = data.id;
					this.$props["form"].staff_ids = data.staff_ids != null && data.staff_ids != '' ? data.staff_ids.split(
						',') : '';
					this.$props["form"].staff_name = data.staff_name;
					this.$props["form"].organize_name = data.organize_name;
					this.$props["form"].spare5 = data.spare5;
				}

				if (data["spare8"] == 'group_company') {
					if (this.$props["form"] != undefined && this.$props["form"] != null) {
						this.$props["form"].id = '';
					}

					if (this.$props["condition"] != undefined && this.$props["condition"] != null) {
						this.$props["condition"].project_id = '';
						this.$props["condition"].flag = 'group';
					}
				} else {
					if (this.$props["condition"] != undefined && this.$props["condition"] != null) {
						this.$props["condition"].flag = '';
					}
				}

				this.$emit('parentFind');
			}, 
			//节点筛选方法
			filterNode(value, data) {
				if (!value) return true;
				return data["organize_name"].indexOf(value) !== -1;
			},
			// 实现局部刷新，在点击弹窗处调用的
			partialRefreshpartialRefresh() {
				// this.node_had.childNodes = []; //把存起来的node的子节点清空，不然会界面会出现重复树！
				// this.loadNode(this.node_had, this.resolve_had); //再次执行懒加载的方法
			}
		},
		created() {}

	};
</script>

<style scoped="scoped">
	.filter-tree {
		background-color: #f7f8fa;
	}

	>>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
		background-color: #EBF4F1 !important;
		border-left: 3px solid #00704C;
	}

	>>>.el-tree-node__content:hover {
		background-color: #EBF4F1 !important;
	}

	>>>.el-tree-node__content {
		height: 35px;
		font-size: 17px;
	}
</style>



// WEBPACK FOOTER //
// structures.vue?1823ae66